export const REQUEST_GROUP_FETCH_EM = "REQUEST_GROUP_FETCH_EM";
export const FETCH_GROUP_EM_SUCCESS = "FETCH_GROUP_EM_SUCCESS";
export const FETCH_GROUP_EM_FAILURE = "FETCH_GROUP_EM_FAILURE";

export const CLEAR_FETCH_GROUP_EM_STATES = "CLEAR_FETCH_GROUP_EM_STATES";
